import { render, staticRenderFns } from "./GStudentRecordCompetencySummary.vue?vue&type=template&id=2ca82513&"
import script from "./GStudentRecordCompetencySummary.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordCompetencySummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports